import axios from "axios";

/**
 * Generate a CDN/asset URL for a static asset path.
 */
export const asset = (path: string): string => {
  const base = import.meta.env.VITE_ASSET_URL ?? "";
  return `${base}/${path}`;
};

/**
 * Upload a file directly to S3 via a presigned URL obtained from the backend.
 * Returns the upload response data (uuid, bucket, key, url).
 */
export const store = async (
  file: File,
  options: {
    progress?: (progress: number) => void;
    signedStorageUrl?: string;
    contentType?: string;
  } = {},
): Promise<App.Data.UploadResponseData> => {
  const response = await axios.post(options.signedStorageUrl ?? "/signed-storage-url", {
    content_type: options.contentType ?? file.type,
  });

  const { headers, ...data } = response.data;

  const uploadHeaders = { ...headers };
  delete uploadHeaders["Host"];

  await axios.put(data.url, file, {
    headers: uploadHeaders,
    onUploadProgress: (progressEvent) => {
      if (options.progress && progressEvent.total) {
        options.progress(progressEvent.loaded / progressEvent.total);
      }
    },
  });

  return data;
};
